import { storage, oid } from './firebase';

export const getCompanyLogo = () =>
  storage.ref().child(`appData/${oid}/logo/logo.jpg`);

export const getDownloadURL = (id) =>
  storage.ref().child(`appData/${oid}/files/${id}`)
  .getDownloadURL().then(function(url) {
    return url;
  });

export const getReceiptDownloadURL = (id) =>
  storage.ref().child(`appData/${oid}/receipts/${id}`)
  .getDownloadURL().then(function(url) {
    return url;
  });

export const getPortfolioDownloadURL = (id) =>
  storage.ref().child(`appData/${oid}/portfolio/${id}`)
  .getDownloadURL().then(function(url) {
    return url;
  });

export const getHeroImageURL = (filename) =>
  storage.ref().child(`website/hero/${filename}`)
  .getDownloadURL().then(function(url) {
    return url;
  });

export const getContactImageURL = (filename) =>
  storage.ref().child(`website/contact/${filename}`)
  .getDownloadURL().then(function(url) {
    return url;
  });

export const uploadInvoice = (id, invoice) =>
  storage.ref().child(`appData/${oid}/invoices/${id}`).put(invoice);

export const uploadBid = (id, bid) =>
  storage.ref().child(`appData/${oid}/bids/${id}`).put(bid);

export const uploadPortfolioFile = (id, file) =>
  storage.ref().child(`appData/${oid}/portfolio/${id}`).put(file);

export const uploadFile = (id, file) =>
  storage.ref().child(`appData/${oid}/files/${id}`).put(file);

export const deleteFile = (id) =>
  storage.ref().child(`appData/${oid}/files/${id}`).delete();



// WEBPACK FOOTER //
// ./src/firebase/storage.js